import apiClient from "./apiClient";

const baseURL = "menu";
export default {
  getMenu() {
    return apiClient.get(baseURL);
  },

  getCategory(text) {
    return apiClient.get(`${baseURL}/category?nama_kategori=${text}`);
  },

  createMenu(data) {
    return apiClient.post(`${baseURL}/create`, data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  getMenuById(id, data) {
    return apiClient.put(`${baseURL}/update/${id}`, data);
  },

  updateMenu(id, data) {
    return apiClient.post(`${baseURL}/update/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  deleteMenu(id) {
    return apiClient.delete(`${baseURL}/delete/${id}`);
  }
};
